import { useMemo } from 'react';

const pushFeature = (target, geo, color) => {
  if (geo?.geometry) {
    target.push({ ...geo, color });
  }
};

const useFeatures = ({ mapData }) => {
  const { farms, geofences, sites } = useMemo(() => {
    const farms = { type: 'FeatureCollection', features: [] };
    const geofences = { type: 'FeatureGroup', features: [] };
    const sites = { type: 'Feature', features: [] };

    mapData?.farms?.forEach(masterGeofence => {
      const properties = {
        ...masterGeofence?.geo_json?.properties,
        id: masterGeofence?.id,
        type: 'geofence',
        identifier: masterGeofence?.identifier,
        is_master: masterGeofence?.is_master,
        name: masterGeofence?.name,
        ...masterGeofence
      };

      pushFeature(farms.features, { ...masterGeofence?.geo_json, properties }, masterGeofence?.color);
    });

    mapData?.geofences?.forEach(geofence => {
      const properties = {
        ...geofence.geo_json?.properties,
        id: geofence.id,
        type: 'geofence',
        identifier: geofence.identifier,
        is_master: geofence.is_master,
        name: geofence.name
      };

      pushFeature(geofences.features, { ...geofence.geo_json, properties }, geofence.color);
    });

    mapData?.sites?.forEach(site => pushFeature(sites.features, site?.geo_json, site?.color));

    return { farms, geofences, sites };
  }, [mapData]);

  return { farms, geofences, sites };
};

export default useFeatures;
